import React from 'react';
import {NavLink} from 'react-router-dom';
import m from './m.svg';
import './header.css';
import classNames from 'classnames';

export const Header = ({updateMenuState, isBackgroundTransparent, hideFullHeader, toggleMenu, isMenuOpen})=>{

  let showMenu = classNames({'show-menu':isMenuOpen});
  let manageHeaderBackground = (isMenuOpen)?'darken-header':(isBackgroundTransparent)?'fadeToTransparent':'fadeToBlack';
  let hideHeader = (hideFullHeader)?'hide-full-header':'show-full-header';

  return (
    <header className={`${manageHeaderBackground} ${hideHeader}`}>
      <div className="header-title d-none d-md-block text-primary">Michael Witt a.k.a. "nohona"</div>

      <nav className="navbar navbar-expand-lg navbar-dark">
        <NavLink className="nav-link d-md-none" exact activeClassName="active" to="/"
                 onClick={() => updateMenuState(true,true)}>
          <img className="logo" src={m} alt="michael witt" width="40" height="40"/>
        </NavLink>

        <button className="navbar-toggler navbar-toggler-custom" type="button" onClick={()=>toggleMenu()} aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation" style={{borderColor: "ffc30f"}}>
          <span className="navbar-toggler-icon">&nbsp;</span>
        </button>
        <div className={classNames('toggle-menu', 'navbar-collapse', {'show-menu':showMenu})} id="navbarSupportedContent">
          <ul className="navbar-nav mr-auto">
            <li className="nav-item">
              <NavLink id="navFirst" className="nav-link-custom " exact activeClassName="active-custom" to="/"
                       onClick={() => updateMenuState(true)}>HOME</NavLink>
            </li>
            {/*<li className="nav-item">*/}
              {/*<NavLink className="nav-link-custom" activeClassName="active-custom" to="/resume"*/}
                       {/*onClick={() => updateMenuState(false)}>RESUME</NavLink>*/}
            {/*</li>*/}
          </ul>
        </div>
      </nav>
    </header>
  )
};


// WEBPACK FOOTER //
// ./src/components/header/Header.js